module["exports"] = [
  "küç.",
  "küçəsi",
  "prospekti",
  "pr.",
  "sahəsi",
  "sh."
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/az/address/street_suffix.js
// module id = 2336
// module chunks = 1609